import React, { useState } from 'react';
import {
  FaSignOutAlt,
  FaLanguage
} from 'react-icons/fa';
import { useAuth } from '../../contexts/AuthContext';
import { Menu, MenuItem } from '@mui/material';
import logo from '../../styles/logo.png';
import { useTranslation } from 'react-i18next';

function Navbar() {
  const { logout } = useAuth();
  const { i18n } = useTranslation();
  const [langMenuAnchor, setLangMenuAnchor] = useState(null);

  const handleLangMenuOpen = (event) => {
    setLangMenuAnchor(event.currentTarget);
  };

  const handleLangMenuClose = () => {
    setLangMenuAnchor(null);
  };

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('language', lang);
    handleLangMenuClose();
  };

  return (
    <nav className="h-[50px] bg-black flex items-center justify-between px-4 text-white">
      <div className="flex items-center space-x-4">
        <div className="flex items-center space-x-3">
          <div className="flex items-center">
            <div className="w-7 h-7 flex items-center justify-center text-white font-bold text-lg mr-2">
              <img src={logo} alt="logo" className="w-full h-full" />
            </div>
            <div className="font-bold text-lg">QRTalkie運營管理平台</div>
          </div>
        </div>
      </div>
      <div className="flex items-center">
        <div className="flex items-center space-x-2">
          {/* <button
            onClick={toggleTheme}
            className="text-skin-secondary hover:text-skin-primary p-2 rounded hover:bg-skin-hover transition-colors"
          >
            {isDark ? <FaSun className="text-lg" /> : <FaMoon className="text-lg" />}
          </button> */}
          {/* <button className="text-skin-secondary hover:text-skin-primary p-2 rounded hover:bg-skin-hover transition-colors">
            <FaSearch className="text-lg" />
          </button>
          <button className="text-skin-secondary hover:text-skin-primary p-2 rounded hover:bg-skin-hover transition-colors">
            <FaQuestionCircle className="text-lg" />
          </button>
          <button className="text-skin-secondary hover:text-skin-primary p-2 rounded hover:bg-skin-hover transition-colors relative">
            <FaRegEnvelope className="text-lg" />
            <span className="absolute top-1 right-1 w-2 h-2 bg-[var(--blue-primary)] rounded-full"></span>
          </button>
          <button className="text-skin-secondary hover:text-skin-primary p-2 rounded hover:bg-skin-hover transition-colors">
            <FaBell className="text-lg" />
          </button> */}
          <button
            onClick={handleLangMenuOpen}
            className="text-white/70 hover:text-white p-2 rounded transition-colors"
          >
            <FaLanguage className="text-lg" />
          </button>
          <Menu
            anchorEl={langMenuAnchor}
            open={Boolean(langMenuAnchor)}
            onClose={handleLangMenuClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <MenuItem onClick={() => changeLanguage('en')}>English</MenuItem>
            <MenuItem onClick={() => changeLanguage('zh')}>中文</MenuItem>
            <MenuItem onClick={() => changeLanguage('zhCn')}>中文(简体)</MenuItem>
          </Menu>

          <button
            onClick={logout}
            className="text-white/70 hover:text-white p-2 rounded transition-colors"
          >
            <FaSignOutAlt className="text-lg" />
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;